import React from "react";
import RegistrationCard from "./RegistrationCard";
import '../Styles/RegistrationCardList.scss';


const RegistrationCardList = ({ queriedRegistrations }) => {

   console.log("card list", queriedRegistrations)
   return (
      <div className="RegistrationCardListContent">
         {Array.isArray(queriedRegistrations) && queriedRegistrations.length > 0 ? (
            queriedRegistrations.map((queriedRegistration) => (
               <RegistrationCard
                  key={queriedRegistration.registration_regist_id} // Ensure `id` exists and is unique
                  queriedRegistration={queriedRegistration}
               />
            ))
         ) : (
            <p className="NoRegistrationsMessage">
               You haven't registered for anything yet. View your registrations here when you register!
            </p>
         )}
      </div>

   )
}

export default RegistrationCardList;